module.exports = [{"toLink":"/","title":"RYOTA KOSHIBA"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/header.json
// module id = WHyA
// module chunks = 0